'use client';
import React from 'react';
import { styled } from '@mui/material/styles';
import Button from './Button.js';
import { Close } from '../icons/index.js';
import { getColor } from '../../../styles/colors.js';
import { ButtonVariant } from './types.js';
import { useTranslation } from 'react-i18next';
export const iconVariants = ['default', 'invert'];
const CloseButton = ({ iconVariant = 'default', ...props }) => {
    const { t } = useTranslation();
    return (React.createElement(StyledButton, { variant: ButtonVariant.Ghost, iconVariant: iconVariant, "aria-label": t('common.close'), ...props, isBlockOnMobile: false, hasOnlyIcon: true },
        React.createElement(Close, null)));
};
const StyledButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'iconVariant',
})(({ theme: { palette }, iconVariant }) => ({
    color: iconVariant === 'default' ? getColor(palette.icon) : getColor(palette.iconInvert),
}));
export default CloseButton;
